export default __webpack_public_path__ + "static/media/home_ghibli_totoro_bus.49bc7dd1.jpg";